// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__32wIQ","clinicsSelect":"styles_clinicsSelect__1uZ--"};